export default {"src":"/_next/static/media/check--yellow-empty.6f5a854c.svg","height":24,"width":24};